export default __webpack_public_path__ + "static/media/Tabela.be731232.svg";